import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  activeTab: string = 'internal';

  constructor(public authService: AuthService) { }

  ngOnInit() {
  if (!this.authService.canAdminInternalUsers()) {
    this.activeTab = 'external';
  }
}

}
